import { CheckboxInput } from '@framework/form/inputs/CheckboxInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { TbIcon } from '@framework/ui/components/icon/TbIcon.tsx';
import { IconForms, IconReceipt } from '@tabler/icons-react';
import { Datatype } from '../../../../expressions/datatype/Datatype.ts';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { type IWidgetConfigurationSlot } from '../../common/config-slots/IWidgetConfigurationSlot.ts';
import { WidgetConfigurationSlotRender } from '../../common/config-slots/WidgetConfigurationSlotRender.tsx';
import { CommonConfigComponent } from '../../inputs/common/CommonInputConfigComponent.tsx';
import { PaymentRowFieldConfig } from './components/PaymentRowFieldConfig.tsx';
import { type IPaymentRowWidget } from './IPaymentRowWidget.ts';

/** Card "Impostazioni Voce di Pagamento". */
const PaymentRowConfigSlot: IWidgetConfigurationSlot = {
  key: 'payment-row-config',
  title: 'Impostazioni Voce di Pagamento',
  icon: <TbIcon icon={IconReceipt} />,
  description: 'Opzioni della voce di costo: esclusione e resoconto.',
  order: 15,
};

/** Card "Impostazioni Campi" della voce di pagamento. */
const PaymentRowFieldsSlot: IWidgetConfigurationSlot = {
  key: 'payment-row-fields',
  title: 'Impostazioni Campi',
  icon: <TbIcon icon={IconForms} />,
  description: 'Configurazione dei campi che compongono la voce di pagamento.',
  order: 16,
};

export interface IPaymentRowConfigComponentProps
  extends IWidgetComponentProps<IPaymentRowWidget> {}

export function PaymentRowConfigComponent(
  props: IPaymentRowConfigComponentProps,
) {
  return (
    <>
      <CommonConfigComponent
        {...props}
        hideConfigDefaultValue
        hideConfigHelpText
        hideConfigPlaceholder
      />

      <WidgetConfigurationSlotRender slot={PaymentRowConfigSlot}>
        <FormItem name="canBeExcluded">
          <CheckboxInput name={'canBeExcluded'}>
            Abilita la possibilità di escludere la voce di costo
          </CheckboxInput>
        </FormItem>

        <FormItem
          name="showReport"
          help="Mostra il resoconto della singola voce di pagamento (imponibile, iva, totale)"
        >
          <CheckboxInput name={'showReport'}>Mostra resoconto</CheckboxInput>
        </FormItem>
      </WidgetConfigurationSlotRender>

      <WidgetConfigurationSlotRender slot={PaymentRowFieldsSlot}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
          }}
        >
          <PaymentRowFieldConfig
            name="description"
            title={'Descrizione'}
            widgetId={props.widget.id}
            datatype={Datatype.String}
          />
          <PaymentRowFieldConfig
            name="baseUnitAmount"
            title={'Importo Unitaio di Listino'}
            widgetId={props.widget.id}
            datatype={Datatype.Number}
          />
          <PaymentRowFieldConfig
            name="quantity"
            title={'Quantità'}
            widgetId={props.widget.id}
            datatype={Datatype.Number}
          />
          <PaymentRowFieldConfig
            name="unit"
            title={'Unità di misura'}
            widgetId={props.widget.id}
            datatype={Datatype.String}
          />
          <PaymentRowFieldConfig
            name="vat"
            title={'Percentuale IVA'}
            widgetId={props.widget.id}
            datatype={Datatype.Number}
          />
          <PaymentRowFieldConfig
            name="discount"
            title={'Percentuale Sconto/Esenzione'}
            widgetId={props.widget.id}
            datatype={Datatype.Number}
          />
        </div>
      </WidgetConfigurationSlotRender>
    </>
  );
}
